module.exports = __webpack_public_path__ + "img/x.80fad433.svg";